import { Link } from 'react-router-dom';
import { CaretRight, Path } from '@phosphor-icons/react';

import { paths } from '../../routes/paths';
import pt from '../../locales/pt';
import { formatFreeEta } from '../../lib/debtDisplayUtils';
import {
  formatPayoffDatePt,
  predictedPayoffDateFromPlan,
} from '../../utils/debtPlanUtils';
import { cn } from '../../utils/cn';

function methodBenefitLabel(method) {
  if (method === 'snowball') return pt.liabilities.plan.snowball;
  if (method === 'avalanche') return pt.liabilities.plan.avalanche;
  return null;
}

/**
 * Hub card linking to the payment plan screen.
 */
export function DebtPlanLinkCard({ plan, className }) {
  const payoffIso = predictedPayoffDateFromPlan(plan);
  const eta =
    formatFreeEta(payoffIso) ||
    (payoffIso ? formatPayoffDatePt(payoffIso) : '');
  const methodLabel = methodBenefitLabel(plan?.method);

  let subtitle = pt.liabilities.planLink.noPlan;
  if (methodLabel && eta) {
    subtitle = pt.liabilities.planLink.withMethod
      .replace('{method}', methodLabel)
      .replace('{date}', eta);
  } else if (methodLabel) {
    subtitle = pt.liabilities.planLink.withMethodNoDate.replace(
      '{method}',
      methodLabel,
    );
  }

  return (
    <Link
      to={paths.dividasPlan}
      className={cn(
        'flex items-center gap-3 rounded-2xl border border-border bg-card p-4 transition-colors hover:border-sage-400/50',
        className,
      )}
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sky-50 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300">
        <Path className="h-4 w-4" aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <p className="font-medium text-foreground">{pt.liabilities.planLink.title}</p>
        <p className="mt-0.5 truncate text-sm text-muted-foreground">{subtitle}</p>
      </div>
      <CaretRight className="h-5 w-5 shrink-0 text-muted-foreground" aria-hidden />
    </Link>
  );
}

export default DebtPlanLinkCard;
